/**
 * Returns true if the provided URL is relative
 * NOTE: we urls without protocl to not be flagged as relative even tho they actually are ie: google.com is a relative url but we want this function to not flag it in order to fix it by appending https://
 * @param {URL} url
 * @return {boolean}
 */
function isRelativeUrl(url) {
  if (url === undefined || url === null) { return false; } // URL not defined
  if (url.indexOf('://') === -1 && url.indexOf('.') > 1) { return false; } // URL has no protocol and it has a "." in it but not at the start (../news/something) then lets treat it as absolute that will have "//" added later ie: google.com (need this soecial case for old urls without protocol)
  if (url.indexOf('//') === 0) { return false; } // URL is protocol-relative (= absolute)
  if (url.indexOf('://') === -1) { return true; } // URL has no protocol (= relative) See first check for exception and notes
  if (url.indexOf('.') === -1) { return true; } // URL does not contain a dot, i.e. no TLD (= relative, possibly REST)
  if (url.indexOf('/') === -1) { return true; } // URL does not contain a single slash (= relative)
  if (url.indexOf(':') > url.indexOf('/')) { return true; } // The first colon comes after the first slash (= relative)
  if (url.indexOf('://') < url.indexOf('.')) { return false; } // Protocol is defined before first dot (= absolute)
  return true; // Anything else must be relative
}

module.exports = isRelativeUrl;
